import React from "react";
import check from "../../icons/icon_check.svg";
import sIcon1 from "../../icons/icon_man_question.svg";
import sIcon2 from "../../icons/icon_bulb.svg";
import shape1 from "../../images/shapes/shape_section_divider_1.svg";

const SolutionSection = () => {
  return (
    <section
      id="id_ico_solution_section"
      className="problem_solution_section section_space pb-0 section_shadow_top section_decoration"
    >
      <div className="decoration_item shape_divider_1">
        <img src={shape1} alt="Shape Divider" />
      </div>

      <div className="container">
        <div
          className="ico_heading_block text-center"
          data-aos="fade-up"
          data-aos-duration="600"
        >
          <h2 className="heading_text mb-0">¿Por qué CruCoin?</h2>
        </div>

        <div
          className="ico_problem_solution_table"
          data-aos="fade-up"
          data-aos-duration="600"
          data-aos-delay="100"
        >
          <div className="column_wrapper">
            {/* ICO Problem Section */}
            <div className="column_problem">
              <h3 className="heading_text">
                <span className="icon">
                  <img src={sIcon1} alt="Icon Man With Question" />
                </span>
                <span className="text">Problemas comunes</span>
              </h3>
              <ul className="iconlist_block unordered_list_block">
                {[
                  {
                    label: "Comisiones altas y ocultas.",
                    info: "Muchas plataformas cobran comisiones excesivas sin transparencia.",
                  },
                  {
                    label: "Procesos lentos y complicados.",
                    info: "Verificaciones largas y múltiples pasos que frustran al usuario.",
                  },
                  {
                    label: "Falta de seguridad real.",
                    info: "Pocas garantías de protección para tu dinero y datos.",
                  },
                  {
                    label: "Limitaciones geográficas.",
                    info: "No disponible en muchos países o con restricciones.",
                  },
                ].map((item, index) => (
                  <li key={index}>
                    <span className="iconlist_icon">
                      <img src={check} alt="Icon Check" />
                    </span>
                    <span className="iconlist_label">
                      {item.label}
                      <small className="iconlist_info">{item.info}</small>
                    </span>
                  </li>
                ))}
              </ul>
            </div>

            {/* ICO Solution Section */}
            <div className="column_solution">
              <h3 className="heading_text">
                <span className="icon">
                  <img src={sIcon2} alt="Icon Bulb" />
                </span>
                <span className="text">Nuestra solución</span>
              </h3>
              <ul className="iconlist_block unordered_list_block">
                {[
                  {
                    label: "Protección total.",
                    info: "Vendedor autorizado, verificación de identidad y la seguridad de Visa y Mastercard.",
                  },
                  {
                    label: "Velocidad instantánea.",
                    info: "Tus USDT llegan en segundos gracias a nuestra infraestructura optimizada.",
                  },
                  {
                    label: "Transparencia real.",
                    info: "Siempre sabrás cuánto pagas y por qué.",
                  },
                  {
                    label: "Costos reducidos.",
                    info: "Polygon y nuestra ruta de pago mantienen las comisiones al mínimo.",
                  },
                ].map((item, index) => (
                  <li key={index}>
                    <span className="iconlist_icon">
                      <img src={check} alt="Icon Check" />
                    </span>
                    <span className="iconlist_label">
                      {item.label}
                      <small className="iconlist_info">{item.info}</small>
                    </span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SolutionSection;
